import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const MoodChart = ({ data = [] }) => {
  // Transform data to handle both mood_score and mood properties and add day names
  const transformedData = data.map(item => {
    const date = new Date(item.date);
    const dayName = date.toLocaleDateString('en-US', { weekday: 'short' });
    return {
      date: dayName, // Show day name instead of date
      mood: item.mood || item.mood_score || 0,
      fullDate: item.date // Keep full date for tooltip
    };
  });
  
  // Show "No Data Available" message only if absolutely no data
  if (transformedData.length === 0) {
    return (
      <div className="w-full h-64 flex items-center justify-center">
        <div className="text-center">
          <div className="text-gray-400 text-lg mb-2">📊</div>
          <p className="text-gray-500">No mood data available</p>
          <p className="text-gray-400 text-sm mt-1">Complete daily check-ins to see your mood trends</p>
        </div>
      </div>
    );
  }

  // Custom tooltip to show full date
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload[0]) {
      const data = payload[0].payload;
      return (
        <div className="bg-gray-800 text-white p-2 rounded shadow-lg">
          <p className="text-sm font-medium">{data.fullDate}</p>
          <p className="text-sm">Mood: {data.mood}</p>
        </div>
      );
    }
    return null;
  };

  // Show chart with available data (even if just 1 day)
  return (
    <div>
      <div className="w-full h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={transformedData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis 
              dataKey="date" 
              stroke="#6b7280"
              fontSize={12}
              tickLine={false}
            />
            <YAxis 
              stroke="#6b7280"
              fontSize={12}
              tickLine={false}
              domain={[0, 10]}
              ticks={[0, 2, 4, 6, 8, 10]}
            />
            <Tooltip content={<CustomTooltip />} />
            <Line 
              type="monotone" 
              dataKey="mood" 
              stroke="#3b82f6" 
              strokeWidth={3}
              dot={{ fill: '#3b82f6', r: 4 }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default MoodChart;
